import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';

import css from './certificate-confirmation-modal.scss';
import DownloadIcon from './assets/download-icon.svg';
import DownloadButton from './components/download-button/download-button';
import {
    useTranslations,
    useCertificateDownloadTranslations
} from './hooks/use-translations';

import SubHeadingHeader from '../../../sub-heading/sub-heading-header/sub-heading-header';
import RankDropdown from '../rank-dropdown/rank-dropdown';
import { TOTAL_CERTIFICATES_TYPE } from '../../../../helpers/constants';

const CertificateConfirmationModal = ({
    certificatesCount,
    certificateType,
    handleDownloadClick
}) => {
    const {
        certificates,
        selectVersion,
        fullColour,
        printerFriendly,
        selectRanksAndVersion
    } = useTranslations();

    const downloadingHeadings = useCertificateDownloadTranslations();
    const downloadHeadingByType = downloadingHeadings[certificateType] || '';

    const gemsDetails = useSelector((state) => state.gemsDetails);
    const showRankDropdown =
        gemsDetails.length > 0 && certificateType !== TOTAL_CERTIFICATES_TYPE;
    const [selectedGems, setSelectedGems] = useState([]);
    useEffect(() => {
        setSelectedGems(gemsDetails);
    }, [gemsDetails]);
    const gemTypes = selectedGems.map((item) => item.gem);
    const gemCount = showRankDropdown
        ? selectedGems.reduce((acc, item) => acc + item.count, 0)
        : certificatesCount;
    const getGemDetails = () => ({
        gemTypes,
        gemCount
    });
    const isDownloadDisabled = showRankDropdown && gemCount === 0;
    return (
        <div className={css.container}>
            <div className={css.heading}>
                {certificateType
                    ? `${downloadHeadingByType}`
                    : `${certificatesCount} ${certificates}`}
            </div>
            <div className={css.info}>
                {showRankDropdown ? selectRanksAndVersion : selectVersion}
            </div>
            {showRankDropdown && (
                <div className={css['rank-dropdown-container']}>
                    <SubHeadingHeader isModal />
                    <RankDropdown
                        certificatesCount={certificatesCount}
                        options={gemsDetails}
                        setSelectedGems={setSelectedGems}
                    />
                </div>
            )}
            <div className={css.buttonsContainer}>
                <DownloadButton
                    title={`${fullColour} (${gemCount})`}
                    icon={DownloadIcon}
                    onClick={() => {
                        if (!isDownloadDisabled) {
                            handleDownloadClick({
                                fullColor: true,
                                ...getGemDetails()
                            });
                        }
                    }}
                    disabled={isDownloadDisabled}
                />
                <DownloadButton
                    title={`${printerFriendly} (${gemCount})`}
                    icon={DownloadIcon}
                    onClick={() => {
                        if (!isDownloadDisabled) {
                            handleDownloadClick({
                                fullColor: false,
                                ...getGemDetails()
                            });
                        }
                    }}
                    disabled={isDownloadDisabled}
                />
            </div>
        </div>
    );
};

CertificateConfirmationModal.propTypes = {
    certificatesCount: PropTypes.number.isRequired,
    certificateType: PropTypes.number,
    handleDownloadClick: PropTypes.func
};

export default styleable(css)(CertificateConfirmationModal);



// WEBPACK FOOTER //
// ./components/certificates/components/certificate-confirmation-modal/certificate-confirmation-modal.js